
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke121aRequest, Sgke121aResponse, Sgke121aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke121aService {

  /**
   * コンストラクタ
   * @param {Sgke121aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke121aService
   */
  constructor(
    public service: Sgke121aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE121A_入金突合初期表示API呼び出し
   * @param {Sgke121aRequest} request 
   * @returns {Observable<Sgke121aResponse>}
   * @memberof UsedSgke121aService
   */
  public doSgke121a(request: Sgke121aRequest): Observable<Sgke121aResponse> {
    return this.service.sgke121aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE121A');
          return throwError(err.message);
        })
      );
  }

}
